import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'

/* eslint-disable */
export const Groupbuy = {
  methods: {
    GroupbuyTip: function() {
      $("#StoreModal").modal('hide')
      this.$swal.fire({
        title: "團購步驟教學",
        html: `
        <div style="text-align: center;">
          <div style="display: inline-block; text-align: left;">
            <p style="font-weight: bold;">😀揪團步驟：</p>
            <p>A) 主揪者請按「發起團購」</p>
            <p>B) 分享超連結給參加者們<div style="padding-left: 20px;">【路徑=會員→團購】</div></p>
            <p>C) 參加者須點餐回傳主揪</p>
            <p>D) 「前往結帳」 可看品項</p>
            <p>E) 主揪須最後點餐並結帳</p>
            <p style="font-weight: bold;">🫡備註：</p>
            <p>#參加者須註冊登入帳號</p>
            <p>#團購期間主揪不能登出</p>
            <p>#主揪能幫他人刪除品項</p>
            <p>#參加者能再次回傳主揪</p>
            <p>#團購連結48小時內有效</p>
            <p>#今日可先點明日的團購</p>
          </div>
        </div>
        `,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "發起團購"
      }).then((result) => { if (result.isConfirmed) this.Groupbuy() })
    },
    Groupbuy: function() {
      if (!Global.User?.id) {
        swal.alertError(Global.MESSAGE.GROUPBUY.LOGIN_REQUIRED, () => this.$router.push({ name: "Login" }))
      }
      this.$axios.post(Global.Domain + '/Groupbuy', {
        userId: Global.User.id,
        shopId: Global.Shop.id,
      })
      .then((response) => {
        let data = response.data
        this.receiveGroupbuy(data)
        this.$router.push({ name: "Groupbuies" })
      })
    },
    receiveGroupbuy: function(data) {
      console.log("團購資訊：", data)
      const GroupbuyChannel = window.Echo.channel('GroupbuyChannel.' + data.Token)
      if (Global.Groupbuy[data.Token] == null) Global.Groupbuy[data.Token] = new Array()
      localStorage.getItem("Groupbuy." + data.Token) ? Global.Groupbuy[data.Token] = JSON.parse(localStorage.getItem("Groupbuy." + data.Token)) : null
      GroupbuyChannel.listen('.GroupbuyEvent', (e) => {
        if (e.isOwn == true) return false
        this.$axios.post(Global.Domain + `/GroupbuyEvent`, {
          isOwn: true,
          Token: data.Token,
          User: e.User,
          Data: e.Data,
        })
        Global.Groupbuy[data.Token].push(e.Data[0])
        localStorage.setItem("Groupbuy." + data.Token, JSON.stringify(Global.Groupbuy[data.Token]))
        Global.emitToastContent("團購有一筆新記錄")
      })
    },
    getUserGroupbuies: function() {
      this.$axios.get(Global.Domain + '/Groupbuies')
      .then((response) => {
        let Groupbuies = response.data
        Groupbuies.forEach((data) => {
          console.log(data)
          this.receiveGroupbuy(data)
        })
      })
    }
  }
}